import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Container, Input, Label, Row } from "reactstrap";
import Select from 'react-select';
import { del, get, post } from "../../../utils/apiUtil";
import FloatingInput from '../../../components/Input';
import FloatingSelect from '../../../components/FloatingSelect';
import { useLocation } from 'react-router-dom';
import ImageUpload from "./ImageUploader";

const JobPostEdit = () => {
    const location = useLocation();
    const jobData = location.state?.jobData;
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const jobTypeOptions = [
        { value: 'Full Time', label: 'Full Time' },
        { value: 'Contract', label: 'Contract' }
    ];

    const jobCategoriesOptions = [
        {
            value: 'Operations',
            label: 'Operations'
        },
        {
            value: 'Engineering',
            label: 'Engineering'
        },
        {
            value: 'Management',
            label: 'Management'
        },
        {
            value: 'Supervisory',
            label: 'Supervisory'
        },
        {
            value: 'Maintenance',
            label: 'Maintenance'
        },
        {
            value: 'Sales',
            label: 'Sales'
        },
        {
            value: 'Logistics',
            label: 'Logistics'
        },
        {
            value: 'Design',
            label: 'Design'
        },
    ];

    const employeeTypeOptions = [
        { value: 'Permanent', label: 'Permanent' },
        { value: 'Freelance', label: 'Freelance' }
    ];

    const positionTypeOptions = [
        { value: 'Junior (Entry Level)', label: 'Junior (Entry Level)' },
        { value: 'Mid Level', label: 'Mid Level' },
        { value: 'Experienced', label: 'Experienced' }
    ];

    const experienceTypeOptions = [
        { value: '0 - 1 year', label: '0 - 1 year' },
        { value: '1 - 2 years', label: '1 - 2 years' },
        { value: '2 - 3 years', label: '2 - 3 years' },
        { value: '3 - 4 years', label: '3 - 4 years' },
        { value: '4 - 5 years', label: '4 - 5 years' },
        { value: '5+ years', label: '5+ years' },
    ];

    const FeaturedJobOptions = [
        { value: '0', label: 'No' },
        { value: '1', label: 'Yes' }
    ];

    const [options, setOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);

    // Fetch states from API
    const fetchStates = async () => {
        const res = await fetch(
            "https://gist.githubusercontent.com/mshafrir/2646763/raw/states_titlecase.json"
        );
        const states = await res.json();
        const formatted = states.map((state) => ({
            value: state.abbreviation,
            label: state.name,
        }));
        setOptions(formatted);
    };

    useEffect(() => {
        fetchStates();
    }, []);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            State: selectedState?.value || "",
        }));
    }, [selectedState]);

    const [logoFile, setLogoFile] = useState(null);
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [formData, setFormData] = useState({
        jobID: "",
        CompanyName: "",
        JobTitle: "",
        JobDescription: "",
        JobType: "",
        JobCategory: "",
        EmployeeType: "",
        PositionLevel: "",
        VacancyCount: "",
        ExperienceRequired: "",
        OfferSalary: "",
        JobLocation: "",
        State: "",
        Responsibilities: "",
        Qualifications: "",
        SkillsExperience: "",
        SkillTags: "",
        Industry: "",
        Featured: "0",
        CoverImage: "",
        CompanyLogo: ""
    });

    useEffect(() => {
        if (jobData) {
            setFormData(prev => ({
                ...prev,
                jobID: jobData.ID || "",
                CompanyName: jobData.CompanyName || "",
                JobTitle: jobData.JobTitle || "",
                JobDescription: jobData.JobDescription || "",
                JobType: jobData.JobType || "",
                JobCategory: jobData.JobCategory || "",
                EmployeeType: jobData.EmployeeType || "",
                PositionLevel: jobData.PositionLevel || "",
                VacancyCount: jobData.VacancyCount || "",
                ExperienceRequired: jobData.ExperienceRequired || "",
                OfferSalary: jobData.OfferSalary || "",
                JobLocation: jobData.JobLocation || "",
                State: jobData.State || "",
                Responsibilities: jobData.Responsibilities || "",
                Qualifications: jobData.Qualifications || "",
                SkillsExperience: jobData.SkillsExperience || "",
                SkillTags: jobData.SkillTags || "",
                Industry: jobData.Industry || "",
                Featured: jobData.Featured?.toString() || "0",
                CoverImage: jobData.CoverImage || "",
                CompanyLogo: jobData.CompanyLogo || "",
            }));
        }
    }, [jobData]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmitOld = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            let logoUrl = formData.CompanyLogo;

            if (logoFile) {
                const uploadData = new FormData();
                uploadData.append('file', logoFile);

                const res = await fetch('/upload-to-cloudinary', {
                    method: 'POST',
                    body: uploadData,
                });

                const data = await res.json();
                if (!data.secure_url) throw new Error('Upload failed');
                logoUrl = data.secure_url;
            }

            const payload = {
                ...formData,
                CompanyLogo: logoUrl,
            };

            const endpoint = jobData ? '/update-job-details' : '/post-new-job';
            const response = await post(endpoint, payload);
            if ([200, 201].includes(response.status)) {
                alert('Job has been saved successfully.');
                navigate('/manage-jobs');
            } else {
                throw new Error(response?.message || 'Something went wrong');
            }
        } catch (error) {
            console.error(error);
            alert(error.message || 'An error occurred while submitting.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const formPayload = new FormData();

            // Append text fields
            Object.keys(formData).forEach((key) => {
                formPayload.append(key, formData[key]);
            });

            // Append files
            if (logoFile) {
                formPayload.append('CompanyLogo', logoFile);
            }
            if (coverImageFile) {
                formPayload.append('CoverImage', coverImageFile);
            }

            const endpoint = jobData ? '/update-job-details' : '/post-new-job';
            const response = await post(endpoint, formPayload);
            if ([200, 201].includes(response.status)) {
                alert('Job has been saved successfully.');
                navigate('/manage-jobs');
            } else {
                throw new Error(response?.message || 'Something went wrong');
            }
        } catch (error) {
            console.error(error);
            alert(error.message || 'An error occurred while submitting.');
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <React.Fragment>
            <section className="section">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="bg-primary-subtle text-primary p-3">
                                <h5 className="mb-0 fs-17">Post a new job</h5>
                            </div>
                        </Col>
                    </Row>

                    <form action="#" className="job-post-form shadow mt-4" onSubmit={handleSubmit}>
                        <div className="job-post-content box-shadow-md rounded-3 p-4">
                            <Row>
                                <Col lg={6}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            name="CompanyName"
                                            label="Company name"
                                            value={formData.CompanyName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </Col>

                                <Col lg={6}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            name="JobTitle"
                                            label="Job Title"
                                            value={formData.JobTitle}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </Col>

                                <Col lg={12}>
                                    <div className="mb-4">
                                        <Label htmlFor="JobDescription">Job Description</Label>
                                        <textarea
                                            id="JobDescription"
                                            name="JobDescription"
                                            className="form-control"
                                            rows="4"
                                            placeholder="Enter Job Description"
                                            value={formData.JobDescription}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="mb-4">
                                        <FloatingSelect
                                            label="Job Type"
                                            name="JobType"
                                            value={formData.JobType}
                                            onChange={handleChange}
                                            options={jobTypeOptions}
                                        />
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="mb-4">
                                        <FloatingSelect
                                            label="Job Category"
                                            name="JobCategory"
                                            value={formData.JobCategory}
                                            onChange={handleChange}
                                            options={jobCategoriesOptions}
                                        />
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="mb-4">
                                        <FloatingSelect
                                            label="Employee Type"
                                            name="EmployeeType"
                                            value={formData.EmployeeType}
                                            onChange={handleChange}
                                            options={employeeTypeOptions}
                                        />
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="mb-4">
                                        <FloatingSelect
                                            label="Position Level"
                                            name="PositionLevel"
                                            value={formData.PositionLevel}
                                            onChange={handleChange}
                                            options={positionTypeOptions}
                                        />
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="mb-4">
                                        <FloatingSelect
                                            label="Required experience"
                                            name="ExperienceRequired"
                                            value={formData.ExperienceRequired}
                                            onChange={handleChange}
                                            options={experienceTypeOptions}
                                        />
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            type="number"
                                            name="VacancyCount"
                                            label="Vacancy Count"
                                            value={formData.VacancyCount}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            name="OfferSalary"
                                            label="Salary range"
                                            value={formData.OfferSalary}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            name="JobLocation"
                                            label="Job Location"
                                            value={formData.JobLocation}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </Col>

                                <Col lg={4}>
                                    <div className="mb-4">
                                        <FloatingSelect
                                            label="State"
                                            name="State"
                                            value={formData.State}
                                            onChange={handleChange}
                                            options={options}
                                        />
                                    </div>
                                </Col>

                                <Col lg={12}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            name="Responsibilities"
                                            label="Responsibilities"
                                            value={formData.Responsibilities}
                                            onChange={handleChange}
                                            required
                                        />
                                        <div className="fs-12 text-danger" style={{ marginTop: '-10px', textAlign: 'right' }}>
                                            Use | as a separator for new value.
                                        </div>
                                    </div>
                                </Col>

                                <Col lg={12}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            name="Qualifications"
                                            label="Qualifications"
                                            value={formData.Qualifications}
                                            onChange={handleChange}
                                            required
                                        />
                                        <div className="fs-12 text-danger" style={{ marginTop: '-10px', textAlign: 'right' }}>
                                            Use | as a separator for new value.
                                        </div>
                                    </div>
                                </Col>

                                <Col lg={12}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            name="SkillsExperience"
                                            label="Skills & Experience"
                                            value={formData.SkillsExperience}
                                            onChange={handleChange}
                                            required
                                        />
                                        <div className="fs-12 text-danger" style={{ marginTop: '-10px', textAlign: 'right' }}>
                                            Use | as a separator for new value.
                                        </div>
                                    </div>
                                </Col>

                                <Col lg={12}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            name="SkillTags"
                                            label="Skill Tags"
                                            value={formData.SkillTags}
                                            onChange={handleChange}
                                            required
                                        />
                                        <div className="fs-12 text-danger" style={{ marginTop: '-10px', textAlign: 'right' }}>
                                            Use | as a separator for new value.
                                        </div>
                                    </div>
                                </Col>

                                <Col lg={6}>
                                    <div className="mb-4">
                                        <FloatingInput
                                            name="Industry"
                                            label="Industry"
                                            value={formData.Industry}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </Col>

                                <Col lg={6}>
                                    <div className="mb-4">
                                        <FloatingSelect
                                            label="Featured Job"
                                            name="Featured"
                                            value={formData.Featured}
                                            onChange={handleChange}
                                            options={FeaturedJobOptions}
                                        />
                                    </div>
                                </Col>

                                <Col lg={6}>
                                    <div className="mb-4 mt-4">
                                        <p className="fs-12 mb-3">Company Logo</p>
                                        <ImageUpload
                                            imageUrl={formData.CompanyLogo}
                                            onImageChange={(fileOrNull) => {
                                                if (fileOrNull instanceof File) {
                                                    setLogoFile(fileOrNull); // new file selected
                                                    setFormData(prev => ({ ...prev, CompanyLogo: "" })); // clear old URL
                                                } else {
                                                    setLogoFile(null); // image deleted
                                                    setFormData(prev => ({ ...prev, CompanyLogo: "" }));
                                                }
                                            }}
                                        />
                                    </div>
                                </Col>

                                <Col lg={6}>
                                    <div className="mb-4 mt-4">
                                        <p className="fs-12 mb-3">Job cover image</p>
                                        <ImageUpload
                                            imageUrl={formData.CoverImage}
                                            onImageChange={(fileOrNull) => {
                                                if (fileOrNull instanceof File) {
                                                    setCoverImageFile(fileOrNull);
                                                    setFormData(prev => ({ ...prev, CoverImage: "" }));
                                                } else {
                                                    setCoverImageFile(null);
                                                    setFormData(prev => ({ ...prev, CoverImage: "" }));
                                                }
                                            }}
                                            aspectRatio="2.5"
                                        />
                                    </div>
                                </Col>

                                <Col lg={12}>
                                    <div className="d-flex justify-content-end gap-2">
                                        {/* <Link to="#" className="btn btn-secondary">Back</Link> */}
                                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                            {isLoading ? "Please wait..." : jobData ? "Update details" : "Post now"}
                                            {/* <i className="mdi mdi-send ms-1"></i> */}
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </form>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default JobPostEdit;
